<template>
  <footer class="footer" role="contentinfo">
    <div class="footer__inner">
      <!-- Col 1 : Marque -->
      <div class="footer__brand">
        <router-link to="/" aria-label="Accueil SupraCare" class="brand__link">
          <img src="@/assets/slide-logo.png" alt="Logo SupraCare" class="brand__logo" />
        </router-link>
        <p class="brand__tagline">
          Solutions & équipements de laboratoire — qualité, réactivité et service.
        </p>
        <div class="footer__social" aria-label="Réseaux sociaux">
          <a href="https://www.facebook.com" target="_blank" rel="noopener" aria-label="Facebook" class="social__btn">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener" aria-label="LinkedIn" class="social__btn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener" aria-label="Instagram" class="social__btn">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>

      <!-- Col 2 : Liens utiles -->
      <nav class="footer__links" aria-label="Liens utiles">
        <h3 class="footer__title">Liens utiles</h3>
        <ul class="links__list">
          <li><router-link to="/" class="link"><i class="fas fa-chevron-right"></i> Accueil</router-link></li>
          <li><router-link to="/certification" class="link"><i class="fas fa-chevron-right"></i> À propos</router-link></li>
          <li><a href="http://www.shop.supracare.ma/produits" class="link" target="_blank" rel="noopener">
            <i class="fas fa-chevron-right"></i> Produits</a>
          </li>
          <li><router-link to="/services" class="link"><i class="fas fa-chevron-right"></i> Services</router-link></li>
          <li><router-link to="/contact" class="link"><i class="fas fa-chevron-right"></i> Contact</router-link></li>
        </ul>
      </nav>

      <!-- Col 3 : Horaires -->
      <div class="footer__hours">
        <h3 class="footer__title"><i class="fas fa-clock"></i> Horaires</h3>
        <ul class="hours__list">
          <li><span>Lun – Ven</span><span>08:30 – 12:30</span></li>
          <li><span>Après-midi</span><span>14:30 – 18:30</span></li>
          <li><span>Samedi</span><span>08:30 – 13:00</span></li>
        </ul>
      </div>

      <!-- Col 4 : Contact -->
      <address class="footer__contact" aria-label="Coordonnées">
        <h3 class="footer__title">Contactez-nous</h3>
        <p class="contact__row">
          <i class="fas fa-map-marker-alt"></i>
          <span>Siège social : Imm 58 Appt A3 Rue Oued Sebou, Agdal – Rabat</span>
        </p>
        <p class="contact__row">
          <i class="fas fa-building"></i>
          <span>Bureau : 12 Bd Hassan Al Alaoui, Rés. Nissrine – Ain Borja, Casablanca</span>
        </p>
        <p class="contact__row">
          <i class="fas fa-envelope"></i>
          <a href="mailto:info@supracare.ma" class="contact__link">info@supracare.ma</a>
        </p>
        <p class="contact__row">
          <i class="fas fa-phone-alt"></i>
          <a href="tel:+212522600506" class="contact__link">+212 522 600 506</a> /
          <a href="tel:+212522620507" class="contact__link">+212 522 620 507</a>
        </p>
      </address>
    </div>

    <div class="footer__bar">
      <p>© {{ new Date().getFullYear() }} SupraCare — Tous droits réservés.</p>
      <div class="bar__links">
        <router-link to="/mentions-legales">Mentions légales</router-link>
        <router-link to="/confidentialite">Confidentialité</router-link>
        <router-link to="/conditions">Conditions d’utilisation</router-link>
      </div>
      <a href="#top" class="to-top" aria-label="Revenir en haut">
        <i class="fas fa-arrow-up"></i>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterI",
};
</script>

<style scoped>
:root {
  --brand: #00998B;         /* Couleur principale demandée */
  --brand-dark: #05305b;    /* Accent foncé */
  --text: #243036;
  --muted: #5f6b73;
  --bg: #ffffff;
  --bar: #0c2c3a;
}

.footer {
  background: linear-gradient(to right,#05305b, white, white);;
  border-top: 1px solid rgba(0,0,0,0.06);
}

.footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 20px;
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1.2fr;
  gap: 32px;
}

.footer__title {
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--brand-dark);
  margin: 0 0 12px;
}

.footer__brand .brand__link { display: inline-flex; align-items: center; }
.brand__logo { max-height: 58px; object-fit: contain; filter: drop-shadow(0 1px 0 rgba(0,0,0,0.03)); }
.brand__tagline { margin: 12px 0 18px; color: var(--muted); line-height: 1.6; }

.footer__social { display: flex; gap: 10px; }
.social__btn {
  width: 36px; height: 36px; border-radius: 999px;
  display: grid; place-items: center;
  background: #eef6f5;
  color: var(--brand-dark);
  transition: transform .2s ease, background .2s ease, box-shadow .2s ease;
}
.social__btn:hover { transform: translateY(-2px); background: #e6f3f1; box-shadow: 0 6px 18px rgba(0,153,139,0.15); }

.links__list { list-style: none; padding: 0; margin: 0; display: grid; gap: 10px; }
.link {
  color: var(--text);
  text-decoration: none;
  display: inline-flex; align-items: center; gap: 8px;
  position: relative;
}
.link i { font-size: .8rem; color: var(--brand); }
.link::after {
  content: ""; position: absolute; left: 0; bottom: -3px;
  width: 0%; height: 2px; background: var(--brand);
  transition: width .25s ease;
}
.link:hover::after { width: 100%; }

.hours__list { list-style: none; padding: 0; margin: 0; display: grid; gap: 8px; }
.hours__list li { display: flex; justify-content: space-between; color: var(--text); background: #f7fbfa; padding: 8px 10px; border-radius: 8px; }

.footer__contact { font-style: normal; }
.contact__row { display: flex; gap: 10px; color: var(--text); margin: 10px 0; line-height: 1.5; }
.contact__row i { color: var(--brand); min-width: 18px; margin-top: 2px; }
.contact__link { color: var(--brand-dark); text-decoration: none; }
.contact__link:hover { text-decoration: underline; }

.footer__bar {
  background: linear-gradient(90deg, var(--brand-dark), #08263a);
  color: #fff;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
  position: relative;
  padding: 14px 20px;
}
.footer__bar p { margin: 0; font-size: 0.9rem; opacity: 0.95; }

.bar__links { display: flex; gap: 16px; }
.bar__links a {
  color: #d9edf0; text-decoration: none; font-size: 0.9rem;
}
.bar__links a:hover { color: #fff; text-decoration: underline; }

.to-top {
  position: absolute; right: 14px; bottom: 14px;
  width: 36px; height: 36px; display: grid; place-items: center;
  border-radius: 10px; background: rgba(255,255,255,0.1); color:#fff;
  backdrop-filter: blur(4px);
  transition: transform .2s ease, background .2s ease;
}
.to-top:hover { transform: translateY(-2px); background: rgba(255,255,255,0.18); }

/* Responsive */
@media (max-width: 1024px) {
  .footer__inner { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 640px) {
  .footer__inner { grid-template-columns: 1fr; padding: 38px 16px; gap: 26px; }
  .brand__logo { max-height: 52px; }
  .hours__list li { padding: 8px 12px; }
  .footer__bar { grid-template-columns: 1fr; padding-right: 58px; }
}

/* Préférence dark si tu as un dark mode global */
@media (prefers-color-scheme: dark) {
  .footer { background: #0e1720; border-top-color: rgba(255,255,255,0.06); }
  .footer__title { color: #73d8cf; }
  .brand__tagline, .link, .contact__row { color: #cfe4e7; }
  .hours__list li { background: #10222a; color: #e3f2f4; }
  .social__btn { background: #10363a; color: #c9efea; }
  .social__btn:hover { background: #134348; }
  .contact__link{ color: #cfe4e7; }
}
</style>
